import { render } from "./SidebarMenuItemBot3.vue?vue&type=template&id=141a3438&scoped=true"
import script from "./SidebarMenuItemBot3.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemBot3.vue?vue&type=script&lang=js"

import "./SidebarMenuItemBot3.vue?vue&type=style&index=0&id=141a3438&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141a3438"]])

export default __exports__